module.exports = {"title":"Kredituak"};